import { Component, Input } from '@angular/core';
import * as d3 from 'd3';
import * as d3layout from 'd3-cloud/build/d3.layout.cloud.js'


@Component({
  selector: 'app-word-chart',
  templateUrl: './WordChart.html'
})

export class WordChartComponent {
  @Input()
  GraphData: any;
  @Input()
  wordlength: any;
  @Input()
  ContainerId: any;
  wordChartId: any;
  myData = [];
  count = 0;
  
  ngAfterViewInit() {    
    this.LoadWordCloud();
  }

  ngOnChanges() {
    this.LoadWordCloud();
    }

    LoadWordCloud(){
      if(this.GraphData == undefined || this.GraphData == null){
        d3.select(this.ContainerId).html("");
        return 0;
      }
      if (this.ContainerId == "containerwordCloudDQT"){         
        this.count = 0;         
      }
      if (this.count>0){return 0}
    else{
    this.myData = [];

    this.myData = this.GraphData;

    var prevObject = Object.keys(this.myData)[0].split(" ");
    if (this.wordlength != prevObject.length) {
      return 0;
    }

    var fill = d3.scaleOrdinal(d3.schemeCategory10);
    var w;
    this.wordChartId = this.ContainerId.split("_")[1];
    if (this.ContainerId == "containerwordCloud_AO" || this.ContainerId == "containerwordCloud_IO" || this.ContainerId == "containerwordCloud_Others") {
      w = document.getElementById(this.ContainerId).offsetWidth;
      this.wordChartId = "wordChart_" + this.wordChartId;
    }
    else if (this.ContainerId == "containerwordCloudDQT"){      
      w =  document.getElementById('containerwordCloudDQT').offsetWidth - 10;      
    }
    else{
      w = document.getElementById('containerwordCloud').offsetWidth - 10;
    }
    // set the dimensions and margins of the graph
    if(w == 0){
      w = 544;
    }
    var margin = { top: 5, right: 10, bottom: 5, left: 10 },
      width = w - margin.left - margin.right,
      height = 310 - margin.top - margin.bottom;

    var height_e = 1
    var width_e = 1;
    var dx2 = 1;
    var dy2 = 1;
    var word_entries = []
    var word_entries2 = []
    word_entries = d3.entries(this.myData);
    word_entries2 = d3.entries(this.myData);
    var wordrange = [];
    var wordrange2 = [];
    this.count = this.count+1;
    if (this.wordlength == 1) {
      wordrange = [5, 55]
      wordrange2 = [5, 55]
    }
    else if (this.wordlength == 2 || this.wordlength == 3) {
      wordrange = [5, 28]
      wordrange2 = [5, 28]

    }
    else if (this.wordlength >= 4 && this.wordlength <= 6) {
      wordrange = [4, 9]
      wordrange2 = [4, 9]
    }
    else {
      wordrange = [5, 28]
      wordrange2 = [4, 9]
      height_e = 1
      width_e = 1;
      dx2 = 1
      dy2 = 1;
    }
    var svg
    var vis
    var maxSize = d3.max(word_entries, function (d) {
      return d.value;
    });
    var minSize = d3.min(word_entries, function (d) {
      return d.value;
    });
    //var fontSizeScale = d3.scalePow().exponent(5).domain([0,1]).range([ 0, 20]);
    // console.log("word_entries",word_entries)

    var xScale = d3.scaleLinear()
      .domain([minSize, maxSize])
      .range(wordrange);

    var xScale2 = d3.scaleLinear()
      .domain([minSize, maxSize])
      .range(wordrange2);



    var that = this
    //  d3layout()
    //    .size([width*width_e, height*height_e])
    //    .words(word_entries)
    //    .padding(2)
    //    .rotate(function() { return 0; })
    //   .text(function(d) { return d.key; })
    //    //.font("Impact")

    //   //.fontSize(function(d) {  return d.value; } )
    //    .on("end", draw)
    //    .start();
    //var fontSize = d3.scale[scale]().range([10, 100]);

    d3layout()
      .size([width * width_e, height * height_e])
      .words(word_entries)
      .padding(1.2)
      .fontSize(function (d) {
        return xScale(+d.value);
      })
      .text(function (d) {
        return d.key;
      })
      .font("Impact")
      .rotate(function (d) {
        return 0;
      })
      .on("end", function (d, b) {
        draw(d, b, that.ContainerId)
      }).start();




    function draw(data, bounds, ContainerId) {
      // console.log(data)
      var w = width,
        h = height
      d3.select("#" + ContainerId).html("");
      //document.getElementsByClassName(wordChartId)[0] != undefined ? document.getElementsByClassName(wordChartId)[0].remove() : "";
      //var ele = document.getElementById(wordChartId);
      svg = d3.select("#" + ContainerId).append("svg").attr("id", "#chart_" + ContainerId).attr("width", width).attr("height", height);
      vis = svg.append("g").attr("transform", "translate(" + [width >> 1, height >> 1] + ")");

      var scaling = bounds ? Math.min(
        w / Math.abs(bounds[1].x - w / 2),
        w / Math.abs(bounds[0].x - w / 2),
        h / Math.abs(bounds[1].y - h / 2),
        h / Math.abs(bounds[0].y - h / 2)) / 2 : 1;



      var text = vis.selectAll("text")
        .data(data, function (d) {
          return d.text.toLowerCase();
        });
      text.transition()
        .attr("transform", function (d) {
          return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
          //   //return "translate(" + [d.x, d.y] + ")rotate(10)";
        })
        .style("font-size", function (d) {
          return d.size + "px";
        });
      text.enter().append("text")
        .attr("text-anchor", "middle")
        .attr("transform", function (d) {
          return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
          //return "translate(" + [d.x, d.y] + ")rotate(10)";
        })
        .style("font-size", function (d) {

          return d.size + "px";
        })
        .text(d => {
          console.log(d.text, d.text.length)
          if (d.text.length > 50) {
            console.log(d.text.substring(0, 47) + '...')
            d = d.text.substring(0, 47) + '...';
          }
          else {
            d = d.text
          }
          return d;
        })

        //.text(d => d.text.length > 12 ? d : null)
        .style("font-family", "Impact")
        // .style("fill", function(d) {
        //   return fill(d.text.toLowerCase());
        // })
        .style("fill", function (d, i) { return fill(i); })

        .append("svg:title")
        .text(function (d, i) { return d.text + " : " + d.value });
      // clickable words


      vis.transition()
        .attr("transform", "translate(" + [w >> 1, h >> 1] + ")scale(" + scaling + ")");
    };



    //  function draw(words) {
    //    console.log((words))
    //   d3.select("#wordChart > g").remove()
    //        d3.select("#wordChart")
    //            .attr("width", width)
    //            .attr("height", height)
    //          .append("g")
    //            .attr("transform", "translate(" + [width >> 1, height >> 1] + ")")
    //          .selectAll("text")
    //            .data(words)
    //          .enter().append("text")
    //            .style("font-size", function(d) { 

    //               return xScale2(d.value)+ "px";

    //            })
    //          // .style("font-family", "Impact")
    //            .style("fill", function(d, i) { return fill(i); })
    //            .attr("text-anchor", "middle")
    //            .attr("transform", function(d) {
    //              return "translate(" + [d.x/dx2, d.y/dy2] + ")rotate(" + d.rotate + ")";
    //            })
    //            .text(function(d,i) { return d.key; })
    //      .append("svg:title")
    //      .text(function(d, i) { return d.text +" : "+ d.value});
    //      }
    d3layout().stop();
  }
    }
  }
